import React, { useState } from 'react';

import { observable, action, runInAction } from 'mobx';
import { observer } from 'mobx-react-lite';

import NewCampaign from './NewCampaign';
import { serialize, deserialize, update } from 'serializr';

import Title from '@vromo/ui/components/Title';
import Button from '@vromo/ui/components/Button';
import styled from '@emotion/styled';

import CampaignCard from './CampaignCard';
import { useStore } from '@vromo/mobx-react';
import { useModals } from '@vromo/ui/components/Modals';
import { useToasts } from '@vromo/ui/components/Toasts';
import { qaLabelCampaigns } from './../../../../common-qa-labels/campaigns';

const CardContainer = styled.div`
    display: flex;
    flex-wrap: wrap;
    padding: 8px;
    flex-direction: row;
    flex-shrink: 0;

    @media (max-width: 950px) {
        flex-direction: column;
        align-items: stretch;
    }
`;

export default observer(function Campaigns() {
    const [newOpen, setNewOpen] = useState(false);
    const {
        authStore,
        authStore: { graph, role },
        campaignStore
    } = useStore('rootStore');

    const modals = useModals();
    const showToast = useToasts();

    function create(campaign) {
        graph.root
            .graph()
            .roles(role.id)
            .campaigns()
            .post([serialize(campaign)])
            .then((response) => {
                runInAction(() => {
                    setNewOpen(false);
                    update(campaignStore.campaigns, response);
                    showToast(`Successfully created campaign ${campaign.name}`, 'success');
                });
            })
            .catch((e) => {
                console.error(e);
                setNewOpen(false);
                showToast(`Something went wrong with creating this campaign. Try again.`, 'error');
            });
    }

    async function deleteCampaign(campaign) {
        if (await modals.confirm('Are you sure you want to delete this campaign?')) {
            graph.root
                .graph()
                .roles(role.id)
                .campaigns(campaign.id)
                .delete()
                .then(() => {
                    runInAction(() => {
                        setNewOpen(false);
                        showToast(`Removed campaign ${campaign.name}`);
                        campaignStore.campaigns.items.remove(campaign);
                    });
                });
        }
    }

    return (
        <>
            <div
                style={{
                    display: 'flex',
                    flexDirection: 'row',
                    justifyContent: 'space-between',
                    alignItems: 'center',
                    padding: '0 16px',
                    flexShrink: 0
                }}>
                <Title>Campaigns</Title>
                <Button
                    onClick={() => setNewOpen(true)}
                    data-testid={qaLabelCampaigns.addCampaignButton}>
                    Add New Campaign
                </Button>
            </div>
            <CardContainer>
                {campaignStore.loaded ? (
                    campaignStore.campaigns.length ? (
                        campaignStore.campaigns.map((campaign) => (
                            <CampaignCard
                                key={campaign.id}
                                campaign={campaign}
                                deleteCampaign={() => deleteCampaign(campaign)}
                            />
                        ))
                    ) : (
                        <i>Click New Campaign to start branding your tracking links.</i>
                    )
                ) : (
                    <div>Loading...</div>
                )}
            </CardContainer>

            <NewCampaign isOpen={newOpen} create={create} onCancel={() => setNewOpen(false)} />
        </>
    );
});
